module.exports = __webpack_public_path__ + "img/icon_test_515.61f7d8ed.png";